
import React, {Component} from 'react';
import {connect} from 'react-redux'
import PrintPreview from './PrintPreview'
import StockStore from '../../stores/StockStore'

class PrintReportStockCheck extends Component {

  constructor(...args){
    super(...args)

    this.state = ({
      check_round: -1,
      all_page:[],
      qu_in: [],
      qu_in_amount:0,
      qu:[],
      qu_amount:0,
      tfoot:[{key:""}],
      data: [],
      check_render_title: [],
      _data: []
    })
    
    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');

  }

  componentWillMount() {
    let {check_render_title} = this.state
    check_render_title.push(1)
  }

  componentDidMount(){
    this.loadData()
  }

  loadData(){
    let that = this       
    
    StockStore.loadStockCheckItem(this.props.stockType,function(result){
      that.setState({data:result.data,_data:JSON.parse(JSON.stringify(result.data))})      
    },function(){
      
    })
  }

  getAmountQty(field) {
    let {_data} = this.state
    let amount = 0
    _data.forEach((item,index)=>{
      let qty = (item[field]===null||item[field]===undefined||item[field]===''||isNaN(item[field])?0:item[field])
      amount += (qty*1)
    })
    return amount
  }

  renderTable(length,index) {
    let {messages} = this.props
    return(
      <table className='table table-responsive table-bordered table-print-report-stock-check'>
        <thead>
          <tr >
            <th className='text-center' style={{width:'50px'}}>{messages['Number']}</th>
            <th className='text-center' style={{width:'120px'}}>{messages['Product Code']}</th>
            <th>{messages['Part Name']}</th>
            <th className='text-center' style={{width:'60px'}}>{messages['Quantity (In System)']}</th>
            <th className='text-center' style={{width:'60px'}}>{messages['Quantity']}</th>
            {/*<th className='text-center' style={{width:'70px'}}></th>*/}
            <th className='text-center' style={{width:'60px'}}>{messages['Shelf']}</th>
            {/*<th className='text-center' style={{width:''}}></th>*/}
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
        {index===length-1?
                <tfoot>
                  <tr>            
                    <th colSpan={3} className='text-center'>{messages['Total Of Item']}</th>
                    <th className='text-center'>{this.getAmountQty('stock_quantity')}</th>
                    <th className='text-center'>{this.getAmountQty('quantity')}</th>
                    {/*<th className='text-right'></th>*/}
                    <th className='text-right'></th>
                    {/*<th className='text-right'></th>*/}
                  </tr>
                </tfoot> 
        :''}    
      </table>
    )
  }

  renderRowData() {
    let {data} = this.state
    // let {qu_in} = this.state
    // let {qu} = this.state
    var i = 0

    return(
      data.map((item, index) => {
        i++  
        if (i<=20) {

          // this.state.check_round++
          // this.state.qu_in_amount = (this.state.qu_in_amount*1) + (item.stock_quantity*1)
          // this.state.qu_amount = (this.state.qu_amount*1) + (item.quantity*1)
          // if (this.state.check_round===data.length-1) {
          //   qu_in.push(this.state.qu_in_amount)
          //   qu.push(this.state.qu_amount)
          // }

          delete data[index]

          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>{item.productcode}</td>
              <td style={{fontSize:"12px"}}>{item.detail}</td>
              <td className='text-center'>{item.stock_quantity}</td>
              <td className='text-center'>{item.quantity}</td>
              {/*<td className='text-center'>{item.unit}</td>*/}
              <td className='text-center'>{item.location}</td>
              {/*<td className='text-center'>{item.remark}</td>*/}
            </tr>
          )
        } else {
          return('')
        }
      })
    )  
  }

  render(){
    let {messages} = this.props
    let {check_render_title} = this.state
    check_render_title.push(1)

    let {all_page} = this.state
    var page = 0

    page = Math.ceil(this.state.data.length / 20)
    for (var i=0;i<page;i++) {
      all_page.push(i)
    }

    if (this.state.all_page.length === 0) {
      let title = ''
      if (check_render_title.length === 3) {
        title = messages['Data Not Found']
      } else {
        title = messages['Fetching']+'..'
      }
      return(
        <div>
          <PrintPreview
            size={'portrait'}
            leftBarTitle={messages['Check Stock Table']}
          >
              <div className={'font-print'}>
                <header className="align-center">
                  <h2 className={this.state.title_destop}>{title}</h2>
                </header>
              </div>
          </PrintPreview>  
        </div>  
      )
    } else {
      return (
        <div>
          <PrintPreview
            size={'portrait'}
            leftBarTitle={messages['Check Stock Table']}
          >
            {
              this.state.all_page.map((item, index) => {
                return(
                    <div className={'font-print'} key={index}>
                      <header className="align-center">
                        <h2 className={this.state.title_destop}>{messages['Check Stock Table']}</h2>
                      </header>
                      {this.renderTable(this.state.all_page.length,index)}
                    </div>
                )
              })
            }  
          </PrintPreview>
        </div>
      )
    }
  }
}


export default PrintReportStockCheck = connect(
  (state) => ({messages: state.message.view.print.PrintReportStockCheck}),null,null,{withRef:true}
)(PrintReportStockCheck);




// WEBPACK FOOTER //
// ./src/view/print/PrintReportStockCheck.js